import React from 'react';

/**
 * Boton en pildora. variant: 'primary' | 'secondary' | 'danger'.
 * Icon es un componente SVG de IconKit (import { ReactComponent as X } from '.../x.svg').
 */
function PillButton({
  variant = 'primary',
  icon: Icon,
  iconRight: IconRight,
  size = 'md',
  disabled = false,
  loading = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'sgc-pill-btn',
    `sgc-pill-btn--${variant}`,
    `sgc-pill-btn--${size}`,
    loading ? 'sgc-pill-btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {Icon && <Icon className="sgc-pill-btn__icon" aria-hidden="true" />}
      {children && <span className="sgc-pill-btn__label">{children}</span>}
      {IconRight && <IconRight className="sgc-pill-btn__icon sgc-pill-btn__icon--right" aria-hidden="true" />}
    </button>
  );
}

export default PillButton;
